import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import RobotaxiLogin from "../../Images/LoginImage.png";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../utils/msalConfig";
import { signinRequest } from "../utils/msalConfigB2C";
import Cookies from 'js-cookie';
import { useMsalInstances } from "../utils/MsalInstancesContext";
import { Logger, LogLevel } from "@azure/msal-browser";
import './LoginPage.css'
import logo from '../../Images/Logo-Horizontal-R.png'; // Adjust the path as necessary

const LoginPage = () => {
  const { instance, accounts } = useMsal();
  const { azureADInstance, b2cInstance } = useMsalInstances();
  // const appVersion = process.env.REACT_APP_VERSION;

  // Create a flag to track if login is in progress
  const [isLoginInProgress, setIsLoginInProgress] = useState(false);

  const Navigate = useNavigate;
  b2cInstance.setLogger(new Logger({
    loggerCallback: (logLevel, message, containsPii) => {
      console.log(`MSAL Log [${logLevel}]:`, message);
    },
    level: LogLevel.Verbose,
    piiLoggingEnabled: false
  }));

  const handleOwnerSiSU = async () => {
    if (isLoginInProgress) return;  // Prevent multiple login attempts

    setIsLoginInProgress(true);  // Set flag to true while login is in progress

    try {
      const response = await b2cInstance.loginPopup(signinRequest);
      Cookies.set("idToken", response.accessToken);
      window.location.href = `${window.location.origin}/dashboard`;
      console.log("Login successful:", response);
    } catch (error) {
      console.error("Login failed:", error);
    } finally {
      setIsLoginInProgress(false);  // Reset the flag when the login process finishes
    }
  };
  const handleEmployeeSignIn = async () => {
    if (isLoginInProgress) return;  // Prevent multiple login attempts

    setIsLoginInProgress(true);  // Set flag to true while login is in progress

    try {
      const response = await azureADInstance.loginPopup(loginRequest);
      Cookies.set("idToken", response.idToken);
      window.location.href = `${window.location.origin}/dashboard`;
      console.log("Login successful:", response);
    } catch (error) {
      console.error("Login failed:", error);
    } finally {
      setIsLoginInProgress(false);  // Reset the flag when the login process finishes
    }
  };
  return (
    <div className="container-fluid p-0">
      <div className="row m-0 vh-100">
        {/* Left Section: Image */}
        <div className="col-md-7 p-0">
          <img src={RobotaxiLogin} alt="Login" className="GeoparkingImage" />
          {/* <div className="version-label">Version.{process.env.REACT_APP_VERSION}</div> */}
        </div>

        {/* Right Section: Centered Content */}
        <div className="col-md-5 d-flex flex-column align-items-center justify-content-center text-center px-5">
          {/* Container to align logo and welcome text */}
          <div className="position-relative w-100 text-center">
            <img src={logo} alt="Logo" className="login-logo logo-align" />
            <h3 className="loginheader">Welcome to Geoparking</h3>
          </div>

          {/* Description */}
          <p className="newloginDescription">
            Effortlessly manage and access your parking spaces.<br />Choose your role to continue.
          </p>

          {/* Login Buttons (Same Width, White Text) */}
          <div className="text-center mt-4 w-50">
            <button className="btn btn-primary text-white w-100 px-4 py-2" onClick={handleOwnerSiSU}>
              Login as Parking Lot Owner/Manager
            </button>
          </div>

          <div className="text-center mt-3 w-50">
            <button className="btn btn-primary text-white w-100 px-4 py-2" onClick={handleEmployeeSignIn}>
              Login as Employee
            </button>
          </div>

          {/* Signup Section */}
          <p className="mt-4">
            New to GeoParking?{" "}
            <Link to="/signup" className="joingeo">
              Join us now
            </Link>{" "}
            and be part of the future!
          </p>
          <div className="divhomePageButton mt-5 pt-3 text-center">
            <Link
              to="/Home"
              className="text-primary text-decoration-underline"
              style={{ cursor: 'pointer' }}
            >
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div> 
  );
}
export default LoginPage;
